export default __webpack_public_path__ + "3d99628ff75bd406103fa725f9db22bf.png";